import { StyleSheet } from 'aphrodite';
import { destructive, titles } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	popup: {
		width: 440,
		maxWidth: '100%',
	},
	title: {
		color: destructive,
	},
	body: {
		color: titles,
		fontSize: 14,
		lineHeight: 1.5,
		marginBottom: 18,
	},
	count: {
		fontWeight: 600,
	},
	label: {
		display: 'block',
		fontSize: 13,
		color: titles,
		marginBottom: 8,
	},
	inputWrap: {
		marginBottom: 8,
	},
});
